function detectiveHttp() {
    return location.protocol + '//'
}

export function detectiveUrl() {
    let router = location.host
    let host = router;
    if (router.indexOf('localhost:') > -1 || router.indexOf('10.27.1.111:') > -1) {
        host = 'hipay.localhost'
        // host = '10.99.104.117'
    }
    return `${detectiveHttp()}${host}`
}
